import{escapeSpecialChars}from"./escape.js";


const testObject=(token)=>token instanceof RegExp;







const serialize=(token)=>{
const source=escapeSpecialChars(token.source);
return`${REGEXP_DELIM}${source}${REGEXP_DELIM}${token.flags}`
};


const testString=(chars)=>
chars[0]===REGEXP_DELIM&&chars.lastIndexOf(REGEXP_DELIM)>1;



const parse=(chars)=>{
const endIndex=chars.lastIndexOf(REGEXP_DELIM);
const regExpString=chars.slice(1,endIndex);
const regExpFlags=chars.slice(endIndex+1);
return new RegExp(regExpString,regExpFlags)
};

const REGEXP_DELIM="/";


const normalize=(token)=>token;


const equals=(tokenA,tokenB)=>
tokenA.source===tokenB.source&&
tokenA.flags===tokenB.flags&&
tokenA.lastIndex===tokenB.lastIndex;

export const REGEXP_TOKEN={
name:"regExp",
testObject,
serialize,
testString,
parse,
normalize,
equals
};